
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb91d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb91d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6yPVR", function(module, exports) {

$parcel$export(module.exports, "jobTpl", function () { return $4c6e33b5a00986a7$export$89261c88770e8dd8; });
const $4c6e33b5a00986a7$var$currencyFormatter = (number)=>{
    const formattedNumber = new Intl.NumberFormat(navigator.language, {
        maximumFractionDigits: 0
    }).format(Number.parseInt(number));
    return formattedNumber;
};
const $4c6e33b5a00986a7$export$ccf4fe4aa03cd670 = (currency, min_salary, max_salary, salary_time)=>{
    let salaryHtml;
    if (currency && salary_time) {
        let currencySymbol = "\u20AC";
        if (currency === "GBP") currencySymbol = "\xa3";
        if (currency === "USD") currencySymbol = "$";
        const salaryTimeUnitMapping = {
            year: "per year",
            month: "a month",
            week: "per week",
            day: "a day",
            hour: "an hour"
        };
        const salaryTimeUnitValue = salary_time.toLowerCase();
        const salaryTimeUnit = salaryTimeUnitMapping[salaryTimeUnitValue];
        if (min_salary && max_salary) salaryHtml = `${currencySymbol} ${$4c6e33b5a00986a7$var$currencyFormatter(min_salary)} - ${currencySymbol} ${$4c6e33b5a00986a7$var$currencyFormatter(max_salary)} ${salaryTimeUnit}`;
        else if (min_salary && !max_salary) salaryHtml = `Min. ${currencySymbol} ${$4c6e33b5a00986a7$var$currencyFormatter(min_salary)} ${salaryTimeUnit}`;
        else if (!min_salary && max_salary) salaryHtml = `Max. ${currencySymbol} ${$4c6e33b5a00986a7$var$currencyFormatter(max_salary)} ${salaryTimeUnit}`;
    }
    return salaryHtml;
};
const $4c6e33b5a00986a7$var$insertBeforeLastSlash = (url, insert)=>{
    const lastSlashIndex = url.lastIndexOf("/");
    if (lastSlashIndex === -1) return url; // If no slash is found, return the original URL
    // Split the URL into two parts: before the last slash and after
    const beforeLastSlash = url.substring(0, lastSlashIndex);
    const afterLastSlash = url.substring(lastSlashIndex);
    // Insert the variable before the last slash
    return `${beforeLastSlash}-${insert}${afterLastSlash}`;
};
const $4c6e33b5a00986a7$export$89261c88770e8dd8 = (job, jobDetailLink, jobFooter)=>{
    const tagsHtml = job.tags.map((tag)=>`<span class="tag">${tag}</span>`).join("");
    const salaryHtml = $4c6e33b5a00986a7$export$ccf4fe4aa03cd670(job.currency, job.min_salary, job.max_salary, job.salary_time);
    const jobTpl = `
        ${jobDetailLink ? `<a href="${$4c6e33b5a00986a7$var$insertBeforeLastSlash(jobDetailLink, job.job_id)}" rel="nofollow" target="_blank">` : ""}
            <article>
                <header>${job.title}</header>
                 ${job.logo ? `<img src="${job.logo}" alt="JS Job logo for: ${job.title}" class="logo" />` : ""}
				<div class="main">
					<ul class="job-details">
						<li><i data-lucide="map-pin"></i> ${job.city}</li>
						${salaryHtml ? `<li><i data-lucide="banknote"></i> ${salaryHtml}</li>` : ""}
						${job.hours ? `<li><i data-lucide="clock"></i> ${job.hours} Hours per Week</li>` : ""}
						${job.education ? `<li><i data-lucide="graduation-cap"></i> ${job.education}</li>` : ""}
						<li><i data-lucide="building"></i> ${job.company}</li>
					</ul>
				</div>
                <footer class="tags">
                    ${tagsHtml}
                </footer>
                ${jobFooter ? jobFooter : ""}
            </article>
        ${jobDetailLink ? "</a>" : ""}`;
    return jobTpl.trim();
};

});

parcelRequire("ky4Q0");

var $dNsOM = parcelRequire("dNsOM");
var $6rz5b = parcelRequire("6rz5b");
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $421649addc38f7a0$var$isArray(value) {
    return !Array.isArray ? $421649addc38f7a0$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $421649addc38f7a0$var$INFINITY = 1 / 0;
function $421649addc38f7a0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$421649addc38f7a0$var$INFINITY ? "-0" : result;
}
function $421649addc38f7a0$var$toString(value) {
    return value == null ? "" : $421649addc38f7a0$var$baseToString(value);
}
function $421649addc38f7a0$var$isString(value) {
    return typeof value === "string";
}
function $421649addc38f7a0$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $421649addc38f7a0$var$isBoolean(value) {
    return value === true || value === false || $421649addc38f7a0$var$isObjectLike(value) && $421649addc38f7a0$var$getTag(value) == "[object Boolean]";
}
function $421649addc38f7a0$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $421649addc38f7a0$var$isObjectLike(value) {
    return $421649addc38f7a0$var$isObject(value) && value !== null;
}
function $421649addc38f7a0$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $421649addc38f7a0$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $421649addc38f7a0$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $421649addc38f7a0$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $421649addc38f7a0$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $421649addc38f7a0$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $421649addc38f7a0$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $421649addc38f7a0$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $421649addc38f7a0$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $421649addc38f7a0$var$hasOwn = Object.prototype.hasOwnProperty;
class $421649addc38f7a0$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $421649addc38f7a0$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $421649addc38f7a0$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($421649addc38f7a0$var$isString(key) || $421649addc38f7a0$var$isArray(key)) {
        src = key;
        path = $421649addc38f7a0$var$createKeyPath(key);
        id = $421649addc38f7a0$var$createKeyId(key);
    } else {
        if (!$421649addc38f7a0$var$hasOwn.call(key, "name")) throw new Error($421649addc38f7a0$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($421649addc38f7a0$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($421649addc38f7a0$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $421649addc38f7a0$var$createKeyPath(name);
        id = $421649addc38f7a0$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $421649addc38f7a0$var$createKeyPath(key) {
    return $421649addc38f7a0$var$isArray(key) ? key : key.split(".");
}
function $421649addc38f7a0$var$createKeyId(key) {
    return $421649addc38f7a0$var$isArray(key) ? key.join(".") : key;
}
function $421649addc38f7a0$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$421649addc38f7a0$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$421649addc38f7a0$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($421649addc38f7a0$var$isString(value) || $421649addc38f7a0$var$isNumber(value) || $421649addc38f7a0$var$isBoolean(value))) list.push($421649addc38f7a0$var$toString(value));
            else if ($421649addc38f7a0$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $421649addc38f7a0$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $421649addc38f7a0$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $421649addc38f7a0$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $421649addc38f7a0$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $421649addc38f7a0$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $421649addc38f7a0$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $421649addc38f7a0$var$Config = {
    ...$421649addc38f7a0$var$BasicOptions,
    ...$421649addc38f7a0$var$MatchOptions,
    ...$421649addc38f7a0$var$FuzzyOptions,
    ...$421649addc38f7a0$var$AdvancedOptions
};
const $421649addc38f7a0$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $421649addc38f7a0$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($421649addc38f7a0$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $421649addc38f7a0$var$FuseIndex {
    constructor({ getFn: getFn = $421649addc38f7a0$var$Config.getFn, fieldNormWeight: fieldNormWeight = $421649addc38f7a0$var$Config.fieldNormWeight } = {}){
        this.norm = $421649addc38f7a0$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($421649addc38f7a0$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($421649addc38f7a0$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$421649addc38f7a0$var$isDefined(doc) || $421649addc38f7a0$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$421649addc38f7a0$var$isDefined(value)) return;
            if ($421649addc38f7a0$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$421649addc38f7a0$var$isDefined(value)) continue;
                    if ($421649addc38f7a0$var$isString(value) && !$421649addc38f7a0$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($421649addc38f7a0$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($421649addc38f7a0$var$isString(value) && !$421649addc38f7a0$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $421649addc38f7a0$var$createIndex(keys, docs, { getFn: getFn = $421649addc38f7a0$var$Config.getFn, fieldNormWeight: fieldNormWeight = $421649addc38f7a0$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $421649addc38f7a0$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($421649addc38f7a0$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $421649addc38f7a0$var$parseIndex(data, { getFn: getFn = $421649addc38f7a0$var$Config.getFn, fieldNormWeight: fieldNormWeight = $421649addc38f7a0$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $421649addc38f7a0$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $421649addc38f7a0$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $421649addc38f7a0$var$Config.distance, ignoreLocation: ignoreLocation = $421649addc38f7a0$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $421649addc38f7a0$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $421649addc38f7a0$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $421649addc38f7a0$var$MAX_BITS = 32;
function $421649addc38f7a0$var$search(text, pattern, patternAlphabet, { location: location = $421649addc38f7a0$var$Config.location, distance: distance = $421649addc38f7a0$var$Config.distance, threshold: threshold = $421649addc38f7a0$var$Config.threshold, findAllMatches: findAllMatches = $421649addc38f7a0$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $421649addc38f7a0$var$Config.minMatchCharLength, includeMatches: includeMatches = $421649addc38f7a0$var$Config.includeMatches, ignoreLocation: ignoreLocation = $421649addc38f7a0$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $421649addc38f7a0$var$MAX_BITS) throw new Error($421649addc38f7a0$var$PATTERN_LENGTH_TOO_LARGE($421649addc38f7a0$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $421649addc38f7a0$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $421649addc38f7a0$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $421649addc38f7a0$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $421649addc38f7a0$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $421649addc38f7a0$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $421649addc38f7a0$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $421649addc38f7a0$var$BitapSearch {
    constructor(pattern, { location: location = $421649addc38f7a0$var$Config.location, threshold: threshold = $421649addc38f7a0$var$Config.threshold, distance: distance = $421649addc38f7a0$var$Config.distance, includeMatches: includeMatches = $421649addc38f7a0$var$Config.includeMatches, findAllMatches: findAllMatches = $421649addc38f7a0$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $421649addc38f7a0$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $421649addc38f7a0$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $421649addc38f7a0$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $421649addc38f7a0$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $421649addc38f7a0$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $421649addc38f7a0$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $421649addc38f7a0$var$MAX_BITS), i);
                i += $421649addc38f7a0$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $421649addc38f7a0$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $421649addc38f7a0$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $421649addc38f7a0$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $421649addc38f7a0$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $421649addc38f7a0$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $421649addc38f7a0$var$ExactMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $421649addc38f7a0$var$InverseExactMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $421649addc38f7a0$var$PrefixExactMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $421649addc38f7a0$var$InversePrefixExactMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $421649addc38f7a0$var$SuffixExactMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $421649addc38f7a0$var$InverseSuffixExactMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $421649addc38f7a0$var$FuzzyMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern, { location: location = $421649addc38f7a0$var$Config.location, threshold: threshold = $421649addc38f7a0$var$Config.threshold, distance: distance = $421649addc38f7a0$var$Config.distance, includeMatches: includeMatches = $421649addc38f7a0$var$Config.includeMatches, findAllMatches: findAllMatches = $421649addc38f7a0$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $421649addc38f7a0$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $421649addc38f7a0$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $421649addc38f7a0$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $421649addc38f7a0$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $421649addc38f7a0$var$IncludeMatch extends $421649addc38f7a0$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $421649addc38f7a0$var$searchers = [
    $421649addc38f7a0$var$ExactMatch,
    $421649addc38f7a0$var$IncludeMatch,
    $421649addc38f7a0$var$PrefixExactMatch,
    $421649addc38f7a0$var$InversePrefixExactMatch,
    $421649addc38f7a0$var$InverseSuffixExactMatch,
    $421649addc38f7a0$var$SuffixExactMatch,
    $421649addc38f7a0$var$InverseExactMatch,
    $421649addc38f7a0$var$FuzzyMatch
];
const $421649addc38f7a0$var$searchersLen = $421649addc38f7a0$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $421649addc38f7a0$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $421649addc38f7a0$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $421649addc38f7a0$var$parseQuery(pattern, options = {}) {
    return pattern.split($421649addc38f7a0$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($421649addc38f7a0$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $421649addc38f7a0$var$searchersLen){
                const searcher = $421649addc38f7a0$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $421649addc38f7a0$var$searchersLen){
                const searcher = $421649addc38f7a0$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $421649addc38f7a0$var$MultiMatchSet = new Set([
    $421649addc38f7a0$var$FuzzyMatch.type,
    $421649addc38f7a0$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $421649addc38f7a0$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $421649addc38f7a0$var$Config.isCaseSensitive, includeMatches: includeMatches = $421649addc38f7a0$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $421649addc38f7a0$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $421649addc38f7a0$var$Config.ignoreLocation, findAllMatches: findAllMatches = $421649addc38f7a0$var$Config.findAllMatches, location: location = $421649addc38f7a0$var$Config.location, threshold: threshold = $421649addc38f7a0$var$Config.threshold, distance: distance = $421649addc38f7a0$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $421649addc38f7a0$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($421649addc38f7a0$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $421649addc38f7a0$var$registeredSearchers = [];
function $421649addc38f7a0$var$register(...args) {
    $421649addc38f7a0$var$registeredSearchers.push(...args);
}
function $421649addc38f7a0$var$createSearcher(pattern, options) {
    for(let i = 0, len = $421649addc38f7a0$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $421649addc38f7a0$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $421649addc38f7a0$var$BitapSearch(pattern, options);
}
const $421649addc38f7a0$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $421649addc38f7a0$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $421649addc38f7a0$var$isExpression = (query)=>!!(query[$421649addc38f7a0$var$LogicalOperator.AND] || query[$421649addc38f7a0$var$LogicalOperator.OR]);
const $421649addc38f7a0$var$isPath = (query)=>!!query[$421649addc38f7a0$var$KeyType.PATH];
const $421649addc38f7a0$var$isLeaf = (query)=>!$421649addc38f7a0$var$isArray(query) && $421649addc38f7a0$var$isObject(query) && !$421649addc38f7a0$var$isExpression(query);
const $421649addc38f7a0$var$convertToExplicit = (query)=>({
        [$421649addc38f7a0$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $421649addc38f7a0$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $421649addc38f7a0$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$421649addc38f7a0$var$isExpression(query)) return next($421649addc38f7a0$var$convertToExplicit(query));
        if ($421649addc38f7a0$var$isLeaf(query)) {
            const key = isQueryPath ? query[$421649addc38f7a0$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$421649addc38f7a0$var$KeyType.PATTERN] : query[key];
            if (!$421649addc38f7a0$var$isString(pattern)) throw new Error($421649addc38f7a0$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $421649addc38f7a0$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $421649addc38f7a0$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($421649addc38f7a0$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$421649addc38f7a0$var$isExpression(query)) query = $421649addc38f7a0$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $421649addc38f7a0$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $421649addc38f7a0$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $421649addc38f7a0$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$421649addc38f7a0$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$421649addc38f7a0$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $421649addc38f7a0$var$transformScore(result, data) {
    data.score = result.score;
}
function $421649addc38f7a0$var$format(results, docs, { includeMatches: includeMatches = $421649addc38f7a0$var$Config.includeMatches, includeScore: includeScore = $421649addc38f7a0$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($421649addc38f7a0$var$transformMatches);
    if (includeScore) transformers.push($421649addc38f7a0$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $421649addc38f7a0$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$421649addc38f7a0$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $421649addc38f7a0$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $421649addc38f7a0$var$FuseIndex)) throw new Error($421649addc38f7a0$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $421649addc38f7a0$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$421649addc38f7a0$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $421649addc38f7a0$var$isString(query) ? $421649addc38f7a0$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $421649addc38f7a0$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($421649addc38f7a0$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $421649addc38f7a0$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $421649addc38f7a0$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$421649addc38f7a0$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $421649addc38f7a0$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $421649addc38f7a0$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($421649addc38f7a0$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $421649addc38f7a0$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$421649addc38f7a0$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$421649addc38f7a0$var$isDefined(value)) return [];
        let matches = [];
        if ($421649addc38f7a0$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$421649addc38f7a0$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$421649addc38f7a0$export$2e2bcd8739ae039.version = "7.0.0";
$421649addc38f7a0$export$2e2bcd8739ae039.createIndex = $421649addc38f7a0$var$createIndex;
$421649addc38f7a0$export$2e2bcd8739ae039.parseIndex = $421649addc38f7a0$var$parseIndex;
$421649addc38f7a0$export$2e2bcd8739ae039.config = $421649addc38f7a0$var$Config;
$421649addc38f7a0$export$2e2bcd8739ae039.parseQuery = $421649addc38f7a0$var$parse;
$421649addc38f7a0$var$register($421649addc38f7a0$var$ExtendedSearch);



var $6yPVR = parcelRequire("6yPVR");
const $bf4de764db3e430d$var$jobboardForm = $("#jobSearch");
const $bf4de764db3e430d$var$jobboardFormSearchButton = $("#jobSearch button");
const $bf4de764db3e430d$var$urlParams = new URLSearchParams(window.location.search);
const $bf4de764db3e430d$var$jobLists = {};
const $bf4de764db3e430d$var$noJobTpl = `
<article>
    <header>
        <h2>No Jobs Found</h2>
    </header>
    <p>We couldn\u{2019}t find any jobs matching your search criteria.</p>
</article>
`;
// detect language and set default county, page init script
const $bf4de764db3e430d$var$countrySelector = $('select[name="country"]');
$bf4de764db3e430d$var$countrySelector.value = navigator.language.slice(-2);
// fallback selector to UK
if ($bf4de764db3e430d$var$countrySelector.value === "") $bf4de764db3e430d$var$countrySelector.value = "UK";
const $bf4de764db3e430d$var$setJobboardHistory = (currentPage, country, searchPattern)=>{
    history.pushState({
        page: currentPage,
        country: country,
        searchPattern: searchPattern
    }, `Page ${currentPage}, pattern ${searchPattern}, country ${country}`, `?page=${currentPage}&country=${country}&searchPattern=${searchPattern}`);
};
const $bf4de764db3e430d$var$renderJobBoard = (searchResult, currentPage, searchPattern, country)=>{
    const jobboard = $("#jobboard");
    const jobsPerPage = 6; // Number of jobs per page
    const maxPages = 20;
    if (searchResult.length > 0) {
        // Calculate the slice of jobs to display
        const end = currentPage * jobsPerPage;
        const jobPage = searchResult.slice(0, end);
        // Determine if the "Show More" button should be displayed
        const howMuchMore = Math.max(0, Math.min(6, searchResult.length - end));
        const moreButton = end < searchResult.length && currentPage < maxPages ? `<hr><div class='show-more'><button id="showMore">Show ${howMuchMore} more jobs</button></div>` : "";
        const moreSpecific = currentPage === maxPages ? '<hr><div class="show-more"><p>Make you search more specific to get better results</p></div>' : "";
        // Render the job board
        jobboard.innerHTML = `
          <p>Showing results 1-${currentPage * jobsPerPage < searchResult.length ? currentPage * jobsPerPage : searchResult.length} of ${searchResult.length} JS jobs</p>
          <hr>
          <div class="grid jobboard" id="jobboard">
            ${jobPage.map((result, index)=>(0, $6yPVR.jobTpl)(result.item, $bf4de764db3e430d$var$jobboardForm.dataset.details)).join("")}
          </div>
          ${moreButton}${moreSpecific}
        `;
        // Add event listener for the "Show More" button
        const moreBtn = $("#showMore");
        if (moreBtn) moreBtn.addEventListener("click", ()=>{
            const newPage = currentPage + 1;
            // Update the browser's history
            $bf4de764db3e430d$var$setJobboardHistory(newPage, country, searchPattern);
            $bf4de764db3e430d$var$renderJobBoard(searchResult, newPage, searchPattern, country); // Re-render with the next set of jobs
        });
    } else jobboard.innerHTML = $bf4de764db3e430d$var$noJobTpl;
    // reinit icons
    (0, $dNsOM.createIcons)({
        icons: $6rz5b
    });
};
const $bf4de764db3e430d$var$jobSearch = async ()=>{
    const searchPattern = $bf4de764db3e430d$var$jobboardForm.querySelector('#jobSearch input[name="search"]').value;
    const country = $bf4de764db3e430d$var$jobboardForm.querySelector('#jobSearch select[name="country"]').value;
    // cache per country, AJAX fetch
    if (!$bf4de764db3e430d$var$jobLists[country]) {
        $bf4de764db3e430d$var$jobboardFormSearchButton.setAttribute("aria-busy", "true");
        const response = await fetch(`${$bf4de764db3e430d$var$jobboardForm.dataset.url}?country=${country}`); // config path
        $bf4de764db3e430d$var$jobLists[country] = await response.json();
    }
    $bf4de764db3e430d$var$jobboardFormSearchButton.removeAttribute("aria-busy");
    const fuseOptions = {
        includeScore: true,
        keys: [
            {
                name: "title",
                weight: 3
            },
            {
                name: "tags",
                weight: 9
            },
            {
                name: "city",
                weight: 9
            },
            {
                name: "company",
                weight: 9
            }
        ]
    };
    const fuse = new (0, $421649addc38f7a0$export$2e2bcd8739ae039)($bf4de764db3e430d$var$jobLists[country], fuseOptions);
    // Join the terms back together with spaces
    const searchResult = fuse.search(searchPattern);
    // get page from url if reload
    const pageParam = $bf4de764db3e430d$var$urlParams.get("page");
    const page = Number.isInteger(Number(pageParam)) && pageParam !== null ? Number(pageParam) : 1;
    // after search, page 1
    $bf4de764db3e430d$var$renderJobBoard(searchResult, page, searchPattern, country);
};
$bf4de764db3e430d$var$jobboardForm.addEventListener("submit", async (e)=>{
    e.preventDefault(); // Stops the form submission
    // Change the pattern
    const searchPattern = $bf4de764db3e430d$var$jobboardForm.querySelector('#jobSearch input[name="search"]').value;
    const country = $bf4de764db3e430d$var$jobboardForm.querySelector('#jobSearch select[name="country"]').value;
    $bf4de764db3e430d$var$setJobboardHistory(1, country, searchPattern);
    $bf4de764db3e430d$var$jobSearch();
});
// INIT page
(()=>{
    // window reload, check params and perform search
    const reloadPage = $bf4de764db3e430d$var$urlParams.get("page");
    const reloadCountry = $bf4de764db3e430d$var$urlParams.get("country");
    const reloadSearchPattern = $bf4de764db3e430d$var$urlParams.get("searchPattern");
    if (reloadPage && reloadCountry && reloadSearchPattern) {
        // fill form
        $bf4de764db3e430d$var$jobboardForm.querySelector('#jobSearch input[name="search"]').value = reloadSearchPattern;
        $bf4de764db3e430d$var$jobboardForm.querySelector('#jobSearch select[name="country"]').value = reloadCountry;
        $bf4de764db3e430d$var$jobSearch();
    }
    (0, $dNsOM.createIcons)({
        icons: $6rz5b
    });
})();


//# sourceMappingURL=index.87489cf7.js.map
